import { render, staticRenderFns } from "./TaxTrustingConfirmation.vue?vue&type=template&id=395849b3&scoped=true"
import script from "./TaxTrustingConfirmation.vue?vue&type=script&lang=js"
export * from "./TaxTrustingConfirmation.vue?vue&type=script&lang=js"
import style0 from "./TaxTrustingConfirmation.vue?vue&type=style&index=0&id=395849b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395849b3",
  null
  
)

export default component.exports